import { render, staticRenderFns } from "./RoundReceiveNumbers.vue?vue&type=template&id=fe010aec&"
import script from "./RoundReceiveNumbers.vue?vue&type=script&lang=js&"
export * from "./RoundReceiveNumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports